<template lang="pug">
  .d-flex.justify-content-center.align-items-center.flex-column.h-100
    h2.mb-4 Add your shop
    form.form.mb-5(@submit.prevent="create")
      .row
        .form-group.col.col-12
          label Name
          input(type="text", v-model="name")
      .row
        .form-group.col.col-12
          label Amazon key
          input(type="text", v-model="key")
      .row
        .form-group.col.col-12
          .form-btn
            button.btn.btn-primary(type="submit") Submit
</template>

<script>
export default {
  data() {
    return {
      name: '',
      key: '',
    };
  },
  methods: {
    create() {
      const data = {
        name: this.name,
        amazon_key: this.key,
      };

      this.$store.dispatch('shops_create', data);
    },
  },
};
</script>
